import styled, {themeGet, device} from '@theme/utils'


export const SingleTestimonialItemTwo = styled.div`
    padding: 30px 35px 60px;
    background-color: #ffffff;
    border-radius: 15px;
    position: relative;
    margin-top: 40px;
`
export const TestimonialPostAuthor = styled.div`
    display: flex;
    align-items: center;
    padding-bottom: 30px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 30px;
`
export const TestimonialAuthorImage = styled.div`
    width: 70px;
    flex: 0 0 auto;
    margin-right: 20px;
`
export const TestimonialAuthorInfo = styled.div`
    
`
export const NameTitle = styled.h4`
    
`
export const Designation = styled.p`
    color: ${themeGet("colors.primary")};
    font-size: 11px;
    margin-top: 10px;
    text-transform: uppercase;
`
export const TestimonialPostContent = styled.div`
    
`
export const TestimonialPostTitle = styled.h5`
    margin-bottom: 25px;
    line-height: 1.6;
`
export const TestimonialDec = styled.p`
    font-size: 14px;
    line-height: 2;
`
